export const createEmptyMessage = () => {
    return {
        date: "New",
        id: new Date().getMilliseconds(),
        name: "D-XXX You",
        speaker: "1",
        body: "「」",
        turn: 1,
        icon: {
            id: "1",
            speaker: "1",
            url: "./icon/nc209713.jpg"
        }
    };
};
